import FeatureGrid from '../components/FeatureGrid';
import SectionHeader from '../components/SectionHeader';
import Seo from '../components/Seo';
import { pageIntros } from '../data/site';

export default function Features() {
  return (
    <>
      <Seo
        title="Features"
        description="Explore DropBridge features for importing supplier products, editing Shopify listings, applying markups, and keeping prices and stock in sync."
        path="/features"
      />
      <section className="pb-8 pt-32">
        <div className="container-page">
          <SectionHeader {...pageIntros.features} />
        </div>
      </section>
      <FeatureGrid />
    </>
  );
}
